import TbComFile from "domain/main/com/file/TbComFile";
import { action, observable, extendObservable } from "mobx";

import TbSysPopEntity from "./TbSysPopEntity";

/**
 * [시스템] 팝업관리
 */
export default class TbSysPop extends TbSysPopEntity {
  @observable private file: TbComFile;
  public constructor(data?) {
    super(data);
    extendObservable(this, data);
    this.file = new TbComFile(data?.file);
  }
  public getFile(): TbComFile {
    return this.file;
  }
  @action
  public setFile(file: TbComFile): void {
    this.file = file;
  }
}
